import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetSportCompetitionsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	first: Types.Scalars['Int']['input'];
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	filter?: Types.InputMaybe<Types.SearchSportCompetitionFilter>;
}>;

export type GetSportCompetitionsQuery = {
	__typename?: 'Query';
	sportCompetitionsV2: {
		__typename?: 'SportCompetitionsConnectionV2';
		totalCount: number;
		edges?: Array<{
			__typename?: 'SportCompetitionsEdgeV2';
			cursor: string;
			node: {
				__typename?: 'SportCompetitionV2';
				id: string;
				objectId: number;
				sport: Types.SportType;
				content: {
					__typename?: 'SportCompetitionContentV2';
					name: string;
					fullPath: string;
					iconUrl?: string | null;
				};
			};
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
	};
};

export const GetSportCompetitionsDocument = gql`
	query GetSportCompetitions(
		$country: Country!
		$language: Language!
		$first: Int!
		$after: String
		$filter: SearchSportCompetitionFilter
	) {
		sportCompetitionsV2(country: $country, first: $first, after: $after, filter: $filter) {
			totalCount
			edges {
				cursor
				node {
					id
					objectId
					sport
					content(country: $country, language: $language) {
						name
						fullPath
						iconUrl
					}
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
		}
	}
`;
